export enum ModalId {
  CreateSavedSearch,
  SearchBar
}

export const ModalPriorities = {};
